<template>
    <div id="container">
        <div id="contents">
            <div class="contents_header">
                <div class="MenuBox">
                    <div class="m1dep">공통코드 관리</div>
                    <div class="m2dep">
                        <ul>
                            <li class="on">공통 분류코드 등록/수정</li>
                            <li class="over" @click="$router.push({name:'ADMCODE02M01'})">공통 코드 등록/수정</li>
                            <li class="over" @click="$router.push({name:'ADMCODE03M01'})">공통 상세코드 등록/수정</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="contents_body">
                <div class="Search">
                    <div class="inner">
                        <div class="select_wrap">
                            <select v-model="input.searchCondition"> 
                                <option value="" label="전체"/>
                                <option value="1" label="업무분류코드"/>
                                <option value="2" label="업무분류코드명" />
                            </select>
                        </div>
                        <input type="text" name="" id="" class="s215" v-model="input.searchKeyword" @keyup.enter="search"/>
                        <div class="select_wrap">
                            <select v-model="input.useAt"> 
                                <option value="" label="사용여부"/>
                                <option value="Y" label="예"/>
                                <option value="N" label="아니요"/>									
                            </select>
                        </div>
                        <span @click="search" class="btn gray">검색</span>
                    </div>
                </div>
                <div class="Board">
                    <table class="Board_type1">
                        <colgroup>
                            <col width="100">
                            <col width="100">
                            <col width="">
                            <col width="100">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>NO</th>
                                <th>업무분류코드</th>
                                <th>업무분류코드명</th>
                                <th>사용여부</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(code, index) in clCodeList" :key="code.clCode">
                                <td scope="row">{{ (pageInfo.pageIndex - 1) * pageInfo.pageSize + (index + 1) }}</td>
                                <td class="over" @click="select(code.clCode)">{{code.clCode}}&nbsp;</td>
                                <td class="over" @click="select(code.clCode)">{{code.clCodeNm}}&nbsp;</td>
                                <td>{{code.useAt}}&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!--페이징 컴포넌트 -->
                <pagingComp :pageInfo="pageInfo" @page-click="goPage"/>
                <!--// 페이징 컴포넌트 -->

                <!--버튼영역-->
                <div class="BtnArea"> 
                    <div class="Btninner right">
                        <span class="btn write" @click="regBtn">등록</span>
                    </div>
                </div>
                <!--//버튼영역-->                

            </div><!--//contents_body-->
        </div><!--//contents-->
    </div>
    <!--//container-->
</template>

<script>
    import pagingComp from "@/components/PagingComp.vue";
    export default {
        components: {
            pagingComp
        },
        data() {
            return {
                input: {
                    searchCondition : '',
                    searchKeyword : '',
                    useAt : ''
                }, // 검색조건

                clCodeList: [],
                pageInfo: {},
                pageIndex: 1
            };
        },
        beforeCreate() { 
            // console.log('beforeCreate');
        },
        created() { 
            // console.log('created');
        },
        beforeMount() { 
            // console.log('beforeMount');
        },
        mounted() { 
            // console.log('mounted');
            this.getClCodeList();
        },
        beforeUpdate() { 
            // console.log('beforeUpdate');
        },
        updated() { 
            // console.log('BBS001M01 update');
        },
        beforeDestroy() {
            // console.log("beforeDestroy");
        },
        destroyed() {
            // console.log("destroyed");
        },
        methods: {

            search() {
                this.pageIndex = 1;
                this.getClCodeList();
            },

            getClCodeList() {

                this.input.pageIndex = this.pageIndex;
            
                this.$.httpPost("/api/code/adm/getClCodeList", this.input)
                    .then((res) => {
                        // console.log(res.data);
                        
                        this.clCodeList = res.data.list;
                        this.pageInfo = res.data.pageInfo;
                    })
                    .catch((err) => {
                        // console.log("=============================");
                        // console.log(err);
                        // console.log(err.response);
                        // console.log("=============================");
                        alert(err
                            .response
                            .data
                            .error_description);
                    });
            },
            
            select(clCode) {
                // 업무분류코드 상세 페이지로 이동
                var page = {
                    name : 'ADMCODE01M02',
                    params : {
                        clCode : clCode
                    }
                }
                this.$router.push(page);
            },
            
            goPage(page) { // console.log(page);
                this.pageIndex = page;
                this.getClCodeList();
            },
            
            regBtn() {
                this.$router.push({name:'ADMCODE01M03'});
            },
            
        }
    };
</script>